import { ExceptionService } from '../services/exception.service';
import { Input, Output, EventEmitter, Component, OnInit } from '@angular/core';
import { TogetherDIPStageContainer } from '../models/app.models';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { TogetherAuctionDIPEntityType } from './../models/enums';
import * as _ from 'lodash-es';
import * as moment from 'moment';
import * as numeral from 'numeral';
import { filter } from 'rxjs/operators';
import { DipStateService } from 'app/services/dip-state-service.service';

@Component({
    selector: 'together-auction-dip-login-edit',
    templateUrl: './dip.login.edit.component.html',
    styleUrls: ['./dip.login.edit.component.scss'],
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPLoginEditComponent implements OnInit {

  /**
   * The stage.
   * TODO: Remove out for state service.
   *
   * @type {TogetherDIPStageContainer}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  @Input() stage: TogetherDIPStageContainer;

  /**
   * The case ID.
   * TODO: Remove out for state service.
   *
   * @type {string}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  @Input() incoming_case_id: string;

  /**
   * The stage changing output event.
   * TODO: Remove out for state service.
   *
   * @type {EventEmitter<string>}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  @Output() stage_changing: EventEmitter<string> = new EventEmitter<string>();

  /**
   * The recap object the component uses.
   * TODO: Type this.
   * @type {object}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  recap: object = {};

  /**
   *
   *
   * @readonly
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  get isDip() {
    return this.state.isDipJourney.getValue();
  }

  /**
   * Returns if the page is loading or not.
   *
   * @readonly
   * @type {boolean}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  get IsLoading(): boolean {
    return this.state.IsLoading;
  }

  /**
   * Gets the current step of the case.
   *
   * @readonly
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  get CurrentStep() {
    if (_.isEmpty(this.recap)) {
      return;
    }

    return _.toInteger(this.recap['CurrentStepId']);
  }

  /**
   * Getter for contue stage.
   *
   * @readonly
   * @type {string}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  get ContinueStage(): string {
    let stepId = _.defaultTo(this.CurrentStep, 100);

    if (stepId === 107 && this.state.isDipJourney) {
      if (_.defaultTo(this.state.DipOutcome, 0) === 1) {
        stepId = 108;
      } else {
        stepId = 106;
      }
    }
    const vals: any = _.find(
      this.state.allStages,
      (x: any) => x.num === stepId,
    );

    return _.defaultTo(vals.reference, 'tad_stage_loan_details');
  }

  /**
   * Getter for continue button text.
   *
   * @readonly
   * @type {string}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  get ContinueButtonText(): string {
    let text = 'Progress my application';

    if (this.state.isDipJourney) {
      if (this.CurrentStep < 107) {
        text = 'Complete pre-approval details';
      } else {
        text = 'Progress to full application';
      }
    }

    return text;
  }

  /**
   * Checks if the case has been submitted
   *
   * @readonly
   * @type {boolean}
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  get IsCaseSubmitted(): boolean {
    if (_.isEmpty(this.recap)) {
      return false;
    }
    return !_.isNil(this.recap['SubmissionReference']);
  }

  /**
   * Switches stage.
   *
   * @param {any} stage
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  gotoStage(stage): void {
    this.stage_changing.emit(stage);
  }

  /**
   * Gets the case detail.
   *
   * @param {any} caseId
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  getCaseDetail(caseId): void {
    this.state.IsLoading = true;
    this.entity.getAllEntities(TogetherAuctionDIPEntityType.Detail, caseId)
      .subscribe(
        (success) => {
          this.recap = (success as any);
          this.state.IsLoading = false;
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this.state.IsLoading = false;
        },
      );
  }

  /**
 * Fetch the DIP certificate from the server
 *
 * @memberof TogetherAuctionDIPOutcomeDetailsComponent
 */
  handleGetDIPCertificate() {
    const cert = this.entity.getDIPCertificate(this.incoming_case_id);
    // tslint:disable-next-line:max-line-length
    const windowOptions = 'menubar=no,toolbar=no,scrollbars=no,resizable=yes,top=300,left=300,width=800,height=1000';
    window.open(cert, 'DIP Certificate', windowOptions);
  }

  /**
   * Handles forward action.
   *
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  onForwardClicked(forward): void {
    if (!this.IsLoading) {
      this.stage_changing.emit(this.ContinueStage);
    }
  }

  /**
   * Implements ngOnInit.
   *
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * Initialises component.
   * TODO: Move this into service.
   *
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  init(): void {
    // Is the entity not new? If so, let's get the details.
    if (this.entity.isNew(this.incoming_case_id) === false) {
      this.getCaseDetail(this.incoming_case_id);
    } else {
      // If we're not allowed to have a new reference, move.
      if (this.entity.allowNew(this.stage.current_stage.reference) === false) {
        this.stage_changing.emit('tad_stage_info');
      }
    }
  }

  /**
   * Creates an instance of TogetherAuctionDIPLoginEditComponent.
   * @param {NodeAPIEntityService} entity
   * @param {DipStateService} state
   * @memberof TogetherAuctionDIPLoginEditComponent
   */
  constructor(private entity: NodeAPIEntityService,
    private state: DipStateService,
    private exception: ExceptionService) { }
}
